/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { Role } from '../models/Role';

export class GetRoleResponse {
  'role': Role;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "role",
      "baseName": "role",
      "type": "Role",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return GetRoleResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

